// extracted by mini-css-extract-plugin
export var blue = "List-module--blue--117af";
export var content = "List-module--content--ef67f";
export var cta = "List-module--cta--e26ea";
export var description = "List-module--description--7ff99";
export var eyebrowText = "List-module--eyebrow-text--e886d";
export var flipped = "List-module--flipped--b689f";
export var green = "List-module--green--6525f";
export var heading = "List-module--heading--6647c";
export var image = "List-module--image--c805b";
export var item = "List-module--item--6df31";
export var list = "List-module--list--df40c";
export var mainHeading = "List-module--main-heading--4a4ac";
export var mobileImage = "List-module--mobile-image--1d00b";
export var number = "List-module--number--8fd2d";
export var pink = "List-module--pink--b879f";
export var purple = "List-module--purple--32b33";